export default "__VITE_ASSET__C9s4ORo$__"